const accordionV2Toggle = document.querySelectorAll('.accordion-v2__toggle');

accordionV2Toggle.forEach((toggle) => {
    const targetContent = toggle.parentElement.querySelector('.accordion-v2__content');
    setTimeout(() => { // short delay before we allow content to animate
        targetContent.classList.add('animate');
    }, 300);

    // add event listener to toggle
    toggle.addEventListener('click', () => {
        targetContent.classList.toggle('hidden');
        targetContent.classList.toggle('show');
        const isActive = toggle.classList.toggle('active');
        toggle.querySelector('span').innerHTML = isActive ? '-' : '+';
    });  

    // check if we have a preview / show more button in our content area
    const showFullContent = targetContent.querySelector('.accordion-v2__preview-view-all');

    if (showFullContent) {
        showFullContent.addEventListener('click', () => { // add click event to show more button
            const descPreview = targetContent.querySelector('.accordion-v2__content-preview');
            const descFull = targetContent.querySelector('.accordion-v2__content-full');

            if (descFull) {
                descFull.classList.remove("hidden");
                descFull.classList.add("show");
                descPreview.remove();
            }
        });
    };
});